<div class="singular-profile-content">
    <app-fn-ui-empty-icon></app-fn-ui-empty-icon>
</div>
